import { createUseStyles } from "react-jss";

export const UserProfileOperationEmailItemStyle = createUseStyles({
    emailContainer: {
        display: "flex",
        justifyContent: "space-between",
        "& i": {
            paddingTop: 15,
        },
    },
    emailContent: {
        display: "flex",
        width: "calc(100% - 50px)",
        "& i": {
            paddingTop: 15,
        },
    },
    addEmail: {
        display: "flex",
        width: 50,
        justifyContent: "flex-end",
        "& i": {
            paddingTop: 15,
        },
    },
});
